export type ProjectStageFormFieldsType = {
  projectId: string;
  stageId: string;
};

const _new = ({projectId, stageId}: ProjectStageFormFieldsType): ProjectStageFormFieldsType => ({
  projectId,
  stageId,
});

const toMutation = ({
  projectId,
  stageId,
}: ProjectStageFormFieldsType): ProjectStageFormFieldsType => ({
  projectId,
  stageId,
});

const ProjectSalesStageForm = {
  new: _new,
  toMutation,
};

export default ProjectSalesStageForm;
